import api from './HttpService';
import { AUTH } from '../configs/ApiActionUrl';

async function login(postData) {
  const res = await api.post(AUTH.LOGIN, postData);
  return res;
}

async function forgetPassword(postData) {
  const res = await api.post(AUTH.FORGOT_PASSWORD, postData);
  return res;
}

async function getResetPassword(code, key) {
  const res = await api.get(`${AUTH.GET_RESET_PASSWORD}?token=${code}&email=${key}`);
  return res;
}

async function resetPassword(postData) {
  const res = await api.post(AUTH.RESET_PASSWORD, postData);
  return res;
}

async function getSetPassword(code, key) {
  const res = await api.get(`${AUTH.GET_SET_PASSWORD}?token=${code}&email=${key}`);
  return res;
}

async function setPassword(postData) {
  const res = await api.post(AUTH.SET_PASSWORD, postData);
  return res;
}

async function updateAccessToken(postData) {
  const res = await api.post(AUTH.UPDATE_ACCESSTOKEN, postData);
  return res;
}

async function logout() {
  const res = await api.post(AUTH.LOGOUT);
  console.log(res, 'res5treggf');
  return res;
}

const AuthService = {
  login,
  logout,
  forgetPassword,
  getResetPassword,
  resetPassword,
  getSetPassword,
  setPassword,
  updateAccessToken
};

export default AuthService;
